import styled from 'styled-components';
//import bg from './img/bg.jpg';
import { useEffect, useRef, useState } from 'react';
import { BRKS } from 'util/variables';
import { useWinResize } from 'zstd/useZstdWinResize';
import beyondx_ssq from './img/beyondx_ssq.svg';
import beyondx_ssq_mobile from './img/beyondx_ssq_mobile.svg';

type Props = {
  children;
};

const videoSrc = `${import.meta.env.VITE_APP_BLOB_STORAGE_CDN_URL}/videos/SSQ_mainpage-movieclip_v2.mp4`;

export const MainWrap = (props: Props) => {
  const { isMobile } = useWinResize();
  const video1 = useRef<HTMLVideoElement>(null);
  const video2 = useRef<HTMLVideoElement>(null);
  const [started, setStarted] = useState(false);
  // useEffect(() => {
  //   const video = document.getElementById('main-bg-video') as HTMLVideoElement;
  //   if (video) {
  //     video.playbackRate = 0.5;
  //     video.setAttribute('defaultMuted', 'true');
  //   }
  // }, []);
  useEffect(() => {
    if (video1.current) {
      video1.current.playbackRate = 0.5;
      video1.current.setAttribute('defaultMuted', 'true');
    }
    if (video2.current) {
      video2.current.playbackRate = 0.5;
      video2.current.setAttribute('defaultMuted', 'true');
    }
  }, []);

  return (
    <Body>
      <BgWrap>
        {/* <Bg src={bg} /> */}
        {/* <BgBlack /> */}
        {/* <BgStyle /> */}
        {started && <BgStyle />}

        <BgVideo
          //autoPlay
          //loop
          muted
          preload='none'
          ref={video1}
          playsInline
          id='main-bg-video'
          style={{ opacity: 0, transition: 'opacity 1s ease-in-out' }}
          onCanPlayThrough={(e) => {
            //console.log('onCanPlayThrough1', e.currentTarget.currentTime);
            (e.currentTarget as HTMLVideoElement).style.opacity = '1';
          }}
          // onEnded={(e) => {
          //   //(e.currentTarget as HTMLVideoElement).style.opacity = '0';
          //   console.log('video1 ended');
          // }}
          onTimeUpdate={(e) => {
            //console.log('timeupdate', e.currentTarget.currentTime);

            const video = e.currentTarget as HTMLVideoElement;
            if (!video) return;
            if (video.duration && video.duration - video.currentTime <= 1) {
              video.style.opacity = '0';
              //video.removeEventListener('timeupdate', fadeoutListener);
              if (video2.current) {
                //console.log('video2 end, video1 start');
                video2.current.style.opacity = '1';
                video2.current.play();
              }
            }
          }}>
          <source src={videoSrc} type='video/mp4' />
        </BgVideo>

        <BgVideo
          autoPlay
          preload='auto'
          //loop
          muted
          ref={video2}
          playsInline
          id='main-bg-video2'
          style={{ opacity: 1, transition: 'opacity 1s ease-in-out' }}
          onCanPlayThrough={(e) => {
            if (!started) setStarted(true);

            //console.log('onCanPlayThrough2', e.currentTarget.currentTime);
            (e.currentTarget as HTMLVideoElement).style.opacity = '1';
          }}
          // onEnded={(e) => {
          //   //(e.currentTarget as HTMLVideoElement).style.opacity = '0';
          //   //console.log('video2 ended');
          // }}
          onTimeUpdate={(e) => {
            //console.log('timeupdate', e.currentTarget.currentTime);

            const video = e.currentTarget as HTMLVideoElement;
            if (!video) return;
            if (video.duration && video.duration - video.currentTime <= 1) {
              video.style.opacity = '0';
              if (video1.current) {
                //console.log('video1 end, video2 start');
                video1.current.style.opacity = '1';
                video1.current.play();
              }
            }
          }}>
          <source src={videoSrc} type='video/mp4' />
        </BgVideo>

        <Logo src={isMobile ? beyondx_ssq_mobile : beyondx_ssq} />
      </BgWrap>
      {props.children}
    </Body>
  );
};

const BgWrap = styled.div`
  position: absolute;
  padding: 4rem;
  width: 100%;

  @media (max-width: ${BRKS.tabletMax}) {
    padding: 0;
  }
`;

const Logo = styled.img`
  position: absolute;
  left: 8rem;
  top: 7.2rem;
  @media (max-width: ${BRKS.tabletMax}) {
    left: 2rem;
    top: 1.8rem;
  }

  @media (max-width: ${BRKS.mobileMax}) {
    top: 5.2rem;
  }
`;

const BgVideo = styled.video`
  border-radius: 1.6rem;
  position: absolute;
  left: 4rem;
  top: 4rem;
  right: 4rem;
  bottom: 4rem;
  width: calc(100% - 8rem);
  height: var(--ssq-main-top-height);
  object-fit: fill;
  @media (max-width: ${BRKS.tabletMax}) {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    border-radius: 0 0 1.6rem 1.6rem;
  }
`;

/*
Bg Image.
*/
const Bg = styled.img`
  border-radius: 1.6rem;
  width: 100%;
  height: var(--ssq-main-top-height);
  @media (max-width: ${BRKS.tabletMax}) {
    border-radius: 0 0 1.6rem 1.6rem;
  }
`;

const BgBlack = styled.div`
  border-radius: 1.6rem;
  width: 100%;
  height: var(--ssq-main-top-height);
  background-color: black;
  @media (max-width: ${BRKS.tabletMax}) {
    border-radius: 0 0 1.6rem 1.6rem;
  }
`;

const BgStyle = styled.div`
  border-radius: 1.6rem;
  width: 100%;
  height: var(--ssq-main-top-height);
  background: radial-gradient(circle at center, #1b2b51 0%, #040611 100%); /* 깊이감 있는 어두운 배경 */
  @media (max-width: ${BRKS.tabletMax}) {
    border-radius: 0 0 1.6rem 1.6rem;
  }
`;

const Body = styled.div``;
